// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"e009e9c4","453":"c1645d48","455":"fd43e323","868":"b6832718","977":"88929cd4"}[chunkId] + ".chunk.js";
};